import React from 'react';

type SectionEyebrowProps = {
  children: React.ReactNode;
  className?: string;
};

export const SectionEyebrow: React.FC<SectionEyebrowProps> = ({ children, className }) => (
  <p
    className={[
      'mb-2 flex items-center gap-2 text-[11px] font-semibold uppercase tracking-[0.18em] text-brandTeal',
      className
    ]
      .filter(Boolean)
      .join(' ')}
  >
    <span className="h-px w-6 rounded-full bg-brandSage/80" aria-hidden />
    {children}
  </p>
);
